module.exports = __webpack_public_path__ + "statics/img/bank-card.1e3b5789.png";